const bindProductTabs = () => {
  document.querySelectorAll('[data-product-tabs]').forEach((section) => {
    const tabs = Array.from(section.querySelectorAll('[role="tab"]'));
    const panels = Array.from(section.querySelectorAll('[role="tabpanel"]'));

    if (!tabs.length || !panels.length) return;

    const activateTab = (index) => {
      tabs.forEach((tab, tabIndex) => {
        const selected = tabIndex === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        tab.classList.toggle('product-tabs__tab--active', selected);
      });

      panels.forEach((panel, panelIndex) => {
        if (panelIndex === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(index));
      tab.addEventListener('keydown', (event) => {
        const keyMap = {
          ArrowRight: 1,
          ArrowLeft: -1,
          ArrowDown: 1,
          ArrowUp: -1,
          Home: 'home',
          End: 'end'
        };

        const direction = keyMap[event.key];
        if (direction === undefined) return;

        event.preventDefault();
        let nextIndex = index;

        if (direction === 'home') {
          nextIndex = 0;
        } else if (direction === 'end') {
          nextIndex = tabs.length - 1;
        } else {
          nextIndex = (index + direction + tabs.length) % tabs.length;
        }

        tabs[nextIndex]?.focus();
        activateTab(nextIndex);
      });
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindProductTabs);
} else {
  bindProductTabs();
}
